/* eslint-disable import/prefer-default-export */
import {
  getResultsCount,
  getSearchId,
  getPostcode,
  getGeohash,
} from '../../selectors/homeSelectors';
import { whichVariant } from '../../selectors/configSelectors';
import { getTrackingHomeOrderType } from '../../selectors/trackingSelectors';
import { MVT_1139, MVT_1146, MVT_1164 } from '../../flags/experiments';

import {
  TRACK_VIEWED_HOME,
  TRACK_VIEWED_COLLECTION,
  TRACK_TAPPED_LAYOUT_BLOCK,
  TRACK_TAPPED_LAYOUT,
  TRACK_VIEWED_COLLECTION_EDUCATION,
  TRACK_DISMISSED_COLLECTION_EDUCATION,
  TRACK_TAPPED_COLLECTION_EDUCATION_EXPLORED,
  TRACK_TAPPED_PICKUP_BANNER,
} from './types';

export function trackViewedHome(extraTrackingProperties = {}) {
  return (dispatch, getState) => {
    const state = getState();
    return dispatch({
      type: TRACK_VIEWED_HOME,
      payload: {
        name: 'Viewed Home',
        properties: {
          ...getTrackingHomeOrderType(state),
          'Number of Restaurants': getResultsCount(state),
          'Served Home Tracking ID': getSearchId(state),
          Postcode: getPostcode(state),
          Geohash: getGeohash(state),
          [MVT_1139]: whichVariant(state, MVT_1139),
          [MVT_1146]: whichVariant(state, MVT_1146),
          [MVT_1164]: whichVariant(state, MVT_1164),
          ...extraTrackingProperties,
        },
      },
    });
  };
}

export function trackViewedCollection() {
  return (dispatch, getState) => {
    const state = getState();

    return dispatch({
      type: TRACK_VIEWED_COLLECTION,
      payload: {
        name: 'Viewed Collection',
        properties: {
          ...getTrackingHomeOrderType(state),
          'Number of Restaurants': getResultsCount(state),
          'Served Home Tracking ID': getSearchId(state),
          [MVT_1139]: whichVariant(state, MVT_1139),
          [MVT_1146]: whichVariant(state, MVT_1146),
        },
      },
    });
  };
}

export function trackTappedLayoutBlock({ layoutTrackingId, blockTrackingId }) {
  return (dispatch, getState) => {
    const state = getState();

    return dispatch({
      type: TRACK_TAPPED_LAYOUT_BLOCK,
      payload: {
        name: 'Tapped Layout Block',
        properties: {
          ...getTrackingHomeOrderType(state),
          'Layout Tracking ID': layoutTrackingId,
          'Block Tracking ID': blockTrackingId,
          'Served Home Tracking ID': getSearchId(state),
        },
      },
    });
  };
}

export function trackTappedLayout(layoutTrackingId) {
  return (dispatch, getState) => {
    const state = getState();

    return dispatch({
      type: TRACK_TAPPED_LAYOUT,
      payload: {
        name: 'Tapped Layout',
        properties: {
          ...getTrackingHomeOrderType(state),
          'Layout Tracking ID': layoutTrackingId,
          'Served Home Tracking ID': getSearchId(state),
        },
      },
    });
  };
}

export function trackViewedCollectionEducation() {
  return (dispatch) =>
    dispatch({
      type: TRACK_VIEWED_COLLECTION_EDUCATION,
      payload: {
        name: 'Showed collection education popup',
        properties: {},
      },
    });
}

export function trackDismissedCollectionEducation() {
  return (dispatch) =>
    dispatch({
      type: TRACK_DISMISSED_COLLECTION_EDUCATION,
      payload: {
        name: 'Dismissed collection education popup',
        properties: {},
      },
    });
}

export function trackTappedCollectionEducationExplored() {
  return (dispatch) =>
    dispatch({
      type: TRACK_TAPPED_COLLECTION_EDUCATION_EXPLORED,
      payload: {
        name: 'Tapped explore pickup',
        properties: {},
      },
    });
}

export function trackTappedPickupBanner() {
  return {
    type: TRACK_TAPPED_PICKUP_BANNER,
    payload: {
      name: 'Tapped pickup banner',
      properties: {},
    },
  };
}
